const TOGGLE_SELECTOR = '.js--menu-btn';
const HEADER_SELECTOR = '.js--site-header';
const DESKTOP_QUERY = '(min-width: 992px)';
const closeMenu = (toggle, header) => {
    toggle.setAttribute('aria-expanded', 'false');
    header.classList.remove('is-open');
    document.documentElement.classList.remove('has-open-mobile-menu');
};
const openMenu = (toggle, header) => {
    toggle.setAttribute('aria-expanded', 'true');
    header.classList.add('is-open');
    document.documentElement.classList.add('has-open-mobile-menu');
};
export const initMobileMenu = () => {
    const toggle = document.querySelector(TOGGLE_SELECTOR);
    const header = toggle?.closest(HEADER_SELECTOR);
    const panelId = toggle?.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!toggle || !header || !panel)
        return;
    toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen)
            closeMenu(toggle, header);
        else
            openMenu(toggle, header);
    });
    panel.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => closeMenu(toggle, header));
    });
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || toggle.getAttribute('aria-expanded') !== 'true')
            return;
        closeMenu(toggle, header);
        toggle.focus({ preventScroll: true });
    });
    window.matchMedia(DESKTOP_QUERY).addEventListener('change', (e) => {
        if (e.matches)
            closeMenu(toggle, header);
    });
};
export default initMobileMenu;
